import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, HashRouter, Routes } from "react-router-dom";
import Admin from "./components/admin/admin";
import Roadmap from "./components/roadmap/roadmap";
import Navbar from "./components/navbar/Navbar.js";
import Home from "./components/home/Home.js";
import Signup from "./components/signup/Singup";
import UserProfile from "./components/UserProfile/Profile.js";
import Task from "./components/Task/Task";
import Dashboard from "./components/dashboard/dashboard";
import Board from "./components/High priority/Board";
import TrelloBoard from "./components/trello-board/Home/Dash";
import Trellosidebar from "./components/Trellosidebar";
import UserForm from "./components/Cvbuilder/UserForm";
import Createbtn from "./components/Createbtn/Createbtn";
import CreateAccordianlink from "./components/Createbtn/CreateAccordianlink";
import CreateBoard from "./components/Createbtn/CreateBoard";
import Forgetpassword from "./components/ForgetPassword/Forgetpassword";
import Preview from "./components/Cvbuilder/Preview";
import PrivateComponent from "./components/privateComponent/PrivateComponent";
import LandingPage from "./components/LandingPage/LandingPage";
import TrackTasks from "./components/TrackTasks/TrackTasks";
import Members from "./components/members/Members";
import WholeDashBoard from "./components/wholeDashboard/WholeDashBoard";
import ContentPost from "./components/ContentPage/ContentPost";
import ContentPage from "./components/ContentPage/ContentPage";
import DragAndDrop from "./components/DragAndDrop";

export default function RouterComponent(props) {
  let { dashData, dashBoard } = props;
  const [token, setToken] = useState();
  const userToken = () => {
    let tokenn = localStorage.getItem("token");
    setToken(tokenn);
  };

  useEffect(() => {
    userToken();
  }, []);
  return (
    <HashRouter>
      {token && <Navbar setToken={setToken} />}
      <Routes>
        <Route element={<PrivateComponent />}>
          <Route path="/task" element={<Task />} />
          <Route path="/board" element={<Board />} />
          <Route path="/drag" element={<DragAndDrop />} />
          <Route path="/" element={<Home />} />
          <Route path="/roadmap/:id" element={<Roadmap />} />
          <Route path="/road" element={<Roadmap />} />
          <Route path="/create" element={<Admin />} />
          <Route path="/UserProfile" element={<UserProfile />} />
          {/* <Route path="/mainDashBoard" element={<WholeDashBoard />} /> */}
          {/* <Route path="/home" element={<Dashboard dashData={dashData} />} /> */}
          <Route path="/:id" element={<Dashboard dashData={dashBoard} />} />
          <Route path="/crt" element={<Createbtn />} />
          <Route path="/crte" element={<CreateBoard />} />
          <Route path="/crtes" element={<CreateAccordianlink />} />
          <Route path="/UserForm" element={<UserForm />} />
          <Route path="/Preview" element={<Preview />} />
          <Route path="/ContentPage" element={<ContentPage />} />
          <Route path="/ContentPostPage" element={<ContentPost />} />
          <Route path="/trellosidebar" element={<Trellosidebar />} />
          <Route path="/trackTasks" element={<TrackTasks dashData={dashData} />} />
          <Route path="/members" element={<Members />} />
        </Route>
        <Route path="/landing" exact element={<LandingPage setToken={setToken} />} />
        <Route path="/Forgetpassword/:id/:token" element={<Forgetpassword />} />
        <Route path="/signup" element={<Signup />} />
        {/* <Route path="/signin" element={<Signin />} /> */}
      </Routes>
    </HashRouter>
  );
}
